import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../assets/images/users3x.png'


const _hoisted_1 = { class: "dashboradPage" }
const _hoisted_2 = {
  key: 1,
  class: "candidateRefDetails"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "personalDetails" }
const _hoisted_5 = { class: "left" }
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "icnsc" }
const _hoisted_9 = { class: "cdonl" }
const _hoisted_10 = {
  key: 0,
  class: "delete"
}
const _hoisted_11 = { class: "recentUpdates" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "Recents update", -1)
const _hoisted_13 = {
  key: 0,
  class: "details"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { key: 4 }
const _hoisted_19 = { class: "bodyaCnt" }
const _hoisted_20 = { class: "requestDetails" }
const _hoisted_21 = { class: "header" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "imgSec" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_23 = { class: "right" }
const _hoisted_24 = { class: "name" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" Request Created ")
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" references for ")
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" references for ")
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" without sending notification. ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Send Reminder ")
const _hoisted_32 = { class: "requestcnt" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" requested references ")
const _hoisted_34 = {
  key: 0,
  class: "refereeLists"
}
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "refereeheader" }
const _hoisted_37 = { class: "first" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Referee Added ")
const _hoisted_39 = {
  key: 0,
  class: "status"
}
const _hoisted_40 = {
  key: 1,
  class: "status"
}
const _hoisted_41 = { class: "body" }
const _hoisted_42 = { class: "title" }
const _hoisted_43 = { class: "first" }
const _hoisted_44 = { class: "icns" }
const _hoisted_45 = { class: "second" }
const _hoisted_46 = { class: "icns" }
const _hoisted_47 = { class: "cnt" }
const _hoisted_48 = {
  key: 0,
  class: "footer"
}
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Send Reminder ")
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Delete ")
const _hoisted_51 = {
  key: 1,
  class: "footer"
}
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" Add Referees ")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Reached the maximum add referee limit")
const _hoisted_54 = /*#__PURE__*/_createTextVNode(" Add Referees ")
const _hoisted_55 = {
  key: 1,
  class: "addRefere"
}
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" Add Referees ")
const _hoisted_57 = {
  key: 0,
  class: "addnewcandidateBtn"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "floating-action" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "badge" }, "New Reference Request")
], -1)
const _hoisted_59 = [
  _hoisted_58
]
const _hoisted_60 = { class: "action-button" }
const _hoisted_61 = {
  key: 2,
  class: "spinners"
}
const _hoisted_62 = { class: "bugcreditSec" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("h2", null, "you dont have enough credits to create new Candidate request.", -1)
const _hoisted_64 = { class: "footersec" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_66 = /*#__PURE__*/_createTextVNode("Purchase")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_addNewCandidateModal = _resolveComponent("addNewCandidateModal")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_DownloadOutlined = _resolveComponent("DownloadOutlined")!
  const _component_DeleteOutlined = _resolveComponent("DeleteOutlined")!
  const _component_SendOutlined = _resolveComponent("SendOutlined")!
  const _component_PhoneOutlined = _resolveComponent("PhoneOutlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_BellOutlined = _resolveComponent("BellOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_UserAddOutlined = _resolveComponent("UserAddOutlined")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_ClockCircleFilled = _resolveComponent("ClockCircleFilled")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_candidateTimeLine = _resolveComponent("candidateTimeLine")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_PlusOutlined = _resolveComponent("PlusOutlined")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_addNewRefereeModal = _resolveComponent("addNewRefereeModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.candidateDetails && _ctx.showCandidatePage)
      ? (_openBlock(), _createBlock(_component_addNewCandidateModal, {
          key: 0,
          From: 'page',
          onGetCandidatesList: _ctx.getAllCandidate
        }, null, 8, ["onGetCandidatesList"]))
      : _createCommentVNode("", true),
    (_ctx.candidateDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: 24,
                  sm: 24,
                  lg: 24,
                  xl: 10
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_a_avatar, {
                          src: 
                    _ctx.candidateDetails.photo
                      ? _ctx.candidateDetails.photo
                      : 'https://ui-avatars.com/api/?background=57429d&name=' +
                        _ctx.candidateDetails.candidate_name +
                        '&rounded=true&color=ffffff'
                  
                        }, null, 8, ["src"])
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createTextVNode(_toDisplayString(_ctx.candidateDetails?.candidate_name) + " ", 1),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("span", {
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.candidatePdf(_ctx.candidateDetails.id)))
                              }, [
                                _createVNode(_component_DownloadOutlined)
                              ])
                            ]),
                            (
                        _ctx.commonService.checkPermission('Candidate', 'delete')
                      )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                  _createElementVNode("span", {
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDeleteConfirm(_ctx.candidateDetails.id)))
                                  }, [
                                    _createVNode(_component_DeleteOutlined)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("ul", null, [
                          _createElementVNode("li", null, [
                            _createVNode(_component_SendOutlined),
                            _createTextVNode(" " + _toDisplayString(_ctx.candidateDetails?.email), 1)
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_PhoneOutlined),
                            _createTextVNode(_toDisplayString(_ctx.candidateDetails?.phone ? _ctx.candidateDetails?.phone : "--"), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: 24,
                  sm: 24,
                  lg: 24,
                  xl: 14
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _hoisted_12,
                      (_ctx.candidateRecentUpdate)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            (_ctx.candidateRecentUpdate.action === 'Reference Created')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.candidateRecentUpdate.action) + " for " + _toDisplayString(_ctx.candidateRecentUpdate.candidate_name) + " by " + _toDisplayString(_ctx.candidateRecentUpdate.request_created_by) + " on " + _toDisplayString(_ctx.candidateRecentUpdate.created_at), 1))
                              : _createCommentVNode("", true),
                            (
                    _ctx.candidateRecentUpdate.action === 'Referee Added' &&
                    _ctx.candidateRecentUpdate.status === 'pending'
                  )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.candidateRecentUpdate.referee_name) + " " + _toDisplayString(_ctx.candidateRecentUpdate.referee_relationship) + " was added as referee by " + _toDisplayString(_ctx.candidateRecentUpdate.request_created_by) + ". Email sent to " + _toDisplayString(_ctx.candidateRecentUpdate.referee_email), 1))
                              : _createCommentVNode("", true),
                            (_ctx.candidateRecentUpdate.action === 'Referee Completed')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.candidateRecentUpdate.referee_name) + " " + _toDisplayString(_ctx.candidateRecentUpdate.referee_relationship) + " has completed the referee request for " + _toDisplayString(_ctx.candidateRecentUpdate.candidate_name) + " on " + _toDisplayString(_ctx.candidateRecentUpdate.created_at), 1))
                              : _createCommentVNode("", true),
                            (
                    _ctx.candidateRecentUpdate.action === 'Referee Added' &&
                    _ctx.candidateRecentUpdate.status === 'Reminded'
                  )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.candidateRecentUpdate.referee_name) + " " + _toDisplayString(_ctx.candidateRecentUpdate.referee_relationship) + " was added as referee by " + _toDisplayString(_ctx.candidateRecentUpdate.request_created_by) + ". Remainder sent to " + _toDisplayString(_ctx.candidateRecentUpdate.referee_email), 1))
                              : _createCommentVNode("", true),
                            (_ctx.candidateRecentUpdate.action === 'Referee Deleted')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.candidateRecentUpdate.referee_name) + " " + _toDisplayString(_ctx.candidateRecentUpdate.referee_relation) + " was deleted by " + _toDisplayString(_ctx.candidateRecentUpdate.request_created_by) + ". on " + _toDisplayString(_ctx.candidateRecentUpdate.created_at), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_a_tabs, {
              activeKey: _ctx.candidateReferencetabKey,
              "onUpdate:activeKey": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.candidateReferencetabKey) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "1",
                  tab: "Reference"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_a_row, { gutter: 16 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_col, {
                              xs: 24,
                              sm: 24,
                              lg: 24,
                              xl: 8,
                              class: "createdBy"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_22,
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _hoisted_25,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.candidateDetails?.request_created_by), 1)
                                  ])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, {
                              xs: 24,
                              sm: 24,
                              lg: 24,
                              xl: 11,
                              class: "createdDetails"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.candidateDetails.is_notify)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                                      _createTextVNode(_toDisplayString(_ctx.candidateDetails?.request_created_by) + " ", 1),
                                      _createElementVNode("span", null, "requested " + _toDisplayString(_ctx.candidateDetails?.reference_required), 1),
                                      _hoisted_27,
                                      _createElementVNode("span", null, _toDisplayString(_ctx.candidateDetails?.candidate_name) + ".", 1),
                                      _createTextVNode(" Request email sent to " + _toDisplayString(_ctx.candidateDetails?.email), 1)
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_28, [
                                      _createTextVNode(_toDisplayString(_ctx.candidateDetails?.request_created_by) + " ", 1),
                                      _createElementVNode("span", null, "requested " + _toDisplayString(_ctx.candidateDetails?.reference_required), 1),
                                      _hoisted_29,
                                      _createElementVNode("span", null, _toDisplayString(_ctx.candidateDetails?.candidate_name) + ".", 1),
                                      _hoisted_30
                                    ]))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, {
                              xs: 24,
                              sm: 24,
                              lg: 24,
                              xl: 5,
                              class: "remainders"
                            }, {
                              default: _withCtx(() => [
                                (
                        _ctx.commonService.checkPermission('Candidate', 'reminder') && _ctx.candidateDetails.is_notify
                      )
                                  ? (_openBlock(), _createBlock(_component_a_button, {
                                      key: 0,
                                      type: "primary",
                                      block: "",
                                      class: "remainder-btn",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sendCandidateRemindar(_ctx.candidateDetails))),
                                      loading: _ctx.candidateRemainderLoading
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_31,
                                        _createVNode(_component_BellOutlined)
                                      ]),
                                      _: 1
                                    }, 8, ["loading"]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_32, [
                                  _hoisted_33,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.candidateDetails?.reference_required), 1)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      (_ctx.candidateDetails?.referees)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createVNode(_component_a_row, { gutter: 16 }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidateDetails.referees, (referess) => {
                                  return (_openBlock(), _createBlock(_component_a_col, {
                                    xs: 24,
                                    sm: 24,
                                    lg: 24,
                                    xl: 12,
                                    key: referess.id
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["singleReferee", 
                        referess.status === 'pending'
                          ? 'pendingreferee'
                          : referess.status === 'completed'
                          ? 'approvedreferee'
                          : referess.status === 'reminded'
                          ? 'remaindedreferee'
                          : ''
                      ]),
                                        onClick: ($event: any) => (_ctx.refereeDetailView(referess))
                                      }, [
                                        _createElementVNode("div", _hoisted_36, [
                                          _createElementVNode("div", _hoisted_37, [
                                            _createVNode(_component_UserAddOutlined),
                                            _hoisted_38
                                          ]),
                                          (
                            referess.status === 'pending' ||
                            referess.status === 'completed'
                          )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                _createVNode(_component_CheckCircleFilled),
                                                _createTextVNode(" " + _toDisplayString(referess.status), 1)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (referess.status === 'reminded')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                _createVNode(_component_ClockCircleFilled),
                                                _createTextVNode(" " + _toDisplayString(referess.status), 1)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_41, [
                                          _createElementVNode("div", _hoisted_42, [
                                            _createElementVNode("div", _hoisted_43, [
                                              _createElementVNode("span", _hoisted_44, [
                                                _createVNode(_component_UserOutlined)
                                              ]),
                                              _createTextVNode(" " + _toDisplayString(referess.referee_name), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_45, [
                                              _createElementVNode("span", _hoisted_46, [
                                                _createVNode(_component_SendOutlined)
                                              ]),
                                              _createTextVNode(" " + _toDisplayString(referess.email), 1)
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_47, _toDisplayString(referess.referee_name) + " " + _toDisplayString(referess.referee_relationship) + " was added as a referee by " + _toDisplayString(referess.referee_created_by) + ". Email sent to " + _toDisplayString(referess.email), 1),
                                          (
                            referess.status === 'pending' ||
                            referess.status === 'reminded'
                          )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                _createVNode(_component_a_button, {
                                                  type: "primary",
                                                  block: "",
                                                  class: "remainder-btn",
                                                  loading: _ctx.refereRemainderLoading,
                                                  onClick: ($event: any) => (_ctx.sendRefereeRemindar(referess))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_49,
                                                    _createVNode(_component_BellOutlined)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["loading", "onClick"]),
                                                (
                              _ctx.commonService.checkPermission('Referee', 'delete')
                            )
                                                  ? (_openBlock(), _createBlock(_component_a_button, {
                                                      key: 0,
                                                      type: "primary",
                                                      block: "",
                                                      class: "delete-btn",
                                                      onClick: ($event: any) => (_ctx.showDeleteRefereeConfirm(referess)),
                                                      loading: _ctx.deleteRefereLoading
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _hoisted_50,
                                                        _createVNode(_component_DeleteOutlined)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick", "loading"]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (referess.status === 'completed')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                                (
                              _ctx.commonService.checkPermission(
                                'Referee',
                                'download'
                              )
                            )
                                                  ? (_openBlock(), _createBlock(_component_a_button, {
                                                      key: 0,
                                                      type: "primary",
                                                      block: "",
                                                      class: "download-btn",
                                                      onClick: ($event: any) => (_ctx.downloadReferee(referess))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_DownloadOutlined)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ], 10, _hoisted_35)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128)),
                                (_ctx.commonService.checkPermission('Referee', 'create'))
                                  ? (_openBlock(), _createBlock(_component_a_col, {
                                      key: 0,
                                      xs: 24,
                                      sm: 24,
                                      lg: 24,
                                      xl: 12,
                                      class: "addNewRefere"
                                    }, {
                                      default: _withCtx(() => [
                                        (
                        _ctx.candidateDetails.referees.length <
                        _ctx.candidateDetails.referee_add_count
                      )
                                          ? (_openBlock(), _createBlock(_component_a_button, {
                                              key: 0,
                                              type: "primary",
                                              block: "",
                                              class: "addRefere-btn",
                                              disabled: 
                        _ctx.candidateDetails.referees.length <
                        _ctx.candidateDetails.referee_add_count
                          ? false
                          : true
                      ,
                                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addNewReferee('second')))
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_52
                                              ]),
                                              _: 1
                                            }, 8, ["disabled"]))
                                          : (_openBlock(), _createBlock(_component_a_tooltip, {
                                              key: 1,
                                              class: "ttip"
                                            }, {
                                              title: _withCtx(() => [
                                                _hoisted_53
                                              ]),
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_button, {
                                                  type: "primary",
                                                  block: "",
                                                  class: "addRefere-btn",
                                                  disabled: true
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_54
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.candidateDetails?.referees)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            (_ctx.commonService.checkPermission('Referee', 'create'))
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  type: "primary",
                                  block: "",
                                  class: "addRefere-btn",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addNewReferee('first')))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_56
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "2",
                  tab: "Timeline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_candidateTimeLine, { candidateId: _ctx.activeCandidateId }, null, 8, ["candidateId"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"]),
            (_ctx.commonService.checkPermission('Candidate', 'create'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["floating-action-menu", _ctx.classApplied === true ? 'active' : ''])
                  }, [
                    _createElementVNode("div", {
                      class: "action-menu",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addNewCandidate()))
                    }, _hoisted_59),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("a", {
                        class: "btn-floating",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showAddNewCandidate()))
                      }, [
                        _createVNode(_component_PlusOutlined)
                      ])
                    ])
                  ], 2)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.dashboardLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      title: "Create Reference Request",
      width: "700px",
      class: "candidate-dashboard-modal",
      visible: _ctx.creatCandidateVisible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.creatCandidateVisible) = $event)),
      "cancel-button-props": { style: 'display:none' },
      "ok-button-props": { style: 'display:none' },
      maskClosable: false,
      destroyOnClose: true,
      centered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_addNewCandidateModal, {
          From: 'modal',
          onCloseCandidateModal: _ctx.closeCandidateModal
        }, null, 8, ["onCloseCandidateModal"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      title: _ctx.addNewRefereeTitle,
      width: "700px",
      class: "candidate-dashboard-modal",
      visible: _ctx.creatRefereeVisible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.creatRefereeVisible) = $event)),
      "cancel-button-props": { style: 'display:none' },
      "ok-button-props": { style: 'display:none' },
      maskClosable: false,
      destroyOnClose: true,
      centered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_addNewRefereeModal, {
          candidateId: _ctx.activeCandidateId,
          From: 'webPage',
          onCloseRefereeModal: _ctx.closeRefereeModal
        }, null, 8, ["candidateId", "onCloseRefereeModal"])
      ]),
      _: 1
    }, 8, ["title", "visible"]),
    _createVNode(_component_a_modal, {
      title: "Buy Credit",
      width: "500px",
      class: "candidate-dashboard-modal purchasecreditModal",
      visible: _ctx.creaditVisible,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.creaditVisible) = $event)),
      "cancel-button-props": { style: 'display:none' },
      "ok-button-props": { style: 'display:none' },
      maskClosable: false,
      destroyOnClose: true,
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _hoisted_63,
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_component_a_button, {
              class: "cancle",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cancleCreditVisible()))
            }, {
              default: _withCtx(() => [
                _hoisted_65
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              class: "add",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.purchaseCredit()))
            }, {
              default: _withCtx(() => [
                _hoisted_66
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}